/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { PromptId } from "../../commons/types/PromptId";
import { AccountId } from "../../commons/types/AccountId";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
import { SpaceId } from "../../commons/types/SpaceId";
import { PromptTypeEnum } from "./PromptTypeEnum";
export const Prompt = core.serialization.object({
    id: PromptId,
    createdById: core.serialization.string(),
    accountId: AccountId,
    environmentId: EnvironmentId.optional(),
    spaceId: SpaceId.optional(),
    promptType: PromptTypeEnum,
    prompt: core.serialization.string(),
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
    deletedAt: core.serialization.date().optional(),
});
